import type { AppLanguage } from '@/shared/i18n/types';

import enFile from './en.json';
import jaFile from './ja.json';

// 取出命名空间数据
const ja = (jaFile as { myCoupon: any }).myCoupon;
const en = (enFile as { myCoupon: any }).myCoupon;

export const myCouponNamespaceResources: Record<AppLanguage, any> = {
  ja,
  en,
};

